import React from 'react'
import SbEditable from 'storyblok-react'
import Link from 'gatsby-theme-kn/src/components/atoms/Link'

const ContactBannerBlock = ({ block }) => {
  return (
    <SbEditable content={block}>
      <section className="contact-banner-block">
        <div className="contact-banner-block-color">
          <div className="contact-banner-block-container">
            <div className="contact-banner-block-wrapper">
              <div className="contact-banner-block-row">
                <div className="contact-banner-block-text">
                  <span className="contact-banner-block-text-inner">
                    {block.text}
                  </span>
                </div>
                <div className="contact-banner-block-embed">
                  {block.buttons?.length > 0 &&
                    block.buttons.map((item, index) => (
                      <Link
                        link={item.link}
                        className="btn btn-primary"
                        key={index}
                      >
                        <span>
                          <i
                            className={`${item.icon?.type} ${item.icon?.icon}`}
                          ></i>
                          {item.link_text}
                        </span>
                      </Link>
                    ))}

                  <div dangerouslySetInnerHTML={{ __html: block.code }}></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </SbEditable>
  )
}

export default ContactBannerBlock
